import React, {useContext} from "react"

export const CheckListContext = React.createContext({
    hier: undefined,
    uniqueIDs: undefined,
    uniqueLabels: undefined,
    setLabelsUpdated: undefined,
    data: undefined,
    setData: undefined,
    saveData: undefined,
    getRec: undefined,
    updateRec: undefined,
    deleteRec: undefined,
    insertRec: undefined,
    genID: undefined,
    moveUp: undefined,
    moveDown: undefined,
    showModal: undefined,
    hideModal: undefined,
    getType: undefined
})

export const useCheckList = () => useContext(CheckListContext)